<template>
  <svg id="icon-trash" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-372.5-12.5h554v512h-554z"/>
      <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
        <path d="M4.5 6.344h11M14.278 6.344V14.9c0 .675-.547 1.222-1.222 1.222H6.944A1.222 1.222 0 0 1 5.722 14.9V6.344m1.834 0V5.122c0-.675.547-1.222 1.222-1.222h2.444c.675 0 1.222.547 1.222 1.222v1.222M8.778 9.4v3.667M11.222 9.4v3.667"/>
      </g>
    </g>
  </svg>
</template>
